/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

/**
 * Adds a SelectItem used for clearing the selected value (it has value 'null') to the existing SelectItem[].
 * May send internationalized label as parameter. If not, the default value of 'All' will be used.
 *
 * Example usage:
 * <p-dropdown... [options]="getObjects() | formatSelectItemEnum | addEmptySelectItemOption:'LABEL STRING HERE'"...>
 */

@Pipe({ name: 'addEmptySelectItemOption' })
@Injectable()
export class AddEmptySelectItemOptionPipe implements PipeTransform {
  transform(value: Array<SelectItem>, labelProperty = 'All'): Array<SelectItem> {
    const clonedValue = Object.assign([], value);
    if (clonedValue) {
      if (clonedValue[0] === undefined || clonedValue[0].value !== null) {
        clonedValue.unshift({ value: null, label: labelProperty });
      }
      return clonedValue;
    }
    return [];
  }
}
